import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";

const PhoneAudioCheck: React.FC = () => {
  let history = useHistory();
  const [TimeOut, SetTimeout] = useState(setTimeout(() => {}));
  const [nextPage, SetNextPage] = useState(true);
  // let nextPage  = true;

  let location =
    window.location.href == window.location.origin + "/phone-audio-check"
      ? true
      : false;
  // const location = useLocation();

  // useEffect(() => {
  //   console.log("Use Effect....... ")
  //   let timeout = setTimeout(function () {
  //     console.log("Moving Out")
  //      history.push("/equipment-needed");
  //   }, 3 * 1000);
  //   SetTimeout(timeout)
  // }, [])
  useEffect(() => {
    let timeout = setTimeout(function () {
      //  history.push("/equipment-needed");
      history.push({
        pathname: "/equipment-needed",
        state: {
          listing: "",
        },
      });
    }, 3 * 1000);
    SetTimeout(timeout);
  }, [location]);
  return (
    <IonPage placeholder={undefined}>
      <IonHeader
        className="ion-no-border phone-header-wraper-for-assessment-setup-pages"
        placeholder={undefined}
      >
        <div
          className="cross-icon"
          onClick={() => {
            clearTimeout(TimeOut);
            history.push("/patient-page");
          }}
        >
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 31C24.5081 31 31 24.5081 31 16.5C31 8.49187 24.5081 2 16.5 2C8.49187 2 2 8.49187 2 16.5C2 24.5081 8.49187 31 16.5 31Z"
              fill="white"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3332 21.3332L11.6667 11.6666"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3333 11.6666L11.6667 21.3333"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="top-inner-sec">
                <div
                  className="left-arrow"
                  onClick={() => {
                    clearTimeout(TimeOut);
                    history.push("/gait-assessment-info");
                  }}
                >
                  <svg
                    className="svg-icons"
                    width="16"
                    height="26"
                    viewBox="0 0 16 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                      fill="#31344E"
                      stroke="black"
                    />
                  </svg>
                </div>
                <h1>Assessment Setup</h1>
                <p> Checking device volume...</p>
                <p> Device volume is on!</p>
                <p>Please turn on your device’s volume to continue.</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid
          className="container inner-content-center"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="phone-audio-check-inner-sec">
                <div className="loader"></div>
                {/* <div className="green-volume">
                  <svg
                    width="97"
                    height="80"
                    viewBox="0 0 97 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M73.4944 26.6148C71.6633 25.1344 68.9682 25.395 67.4827 27.2191C65.9853 29.038 66.2525 31.722 68.0838 33.2124C70.0922 34.8569 71.25 37.2371 71.25 39.5996C71.25 42.1167 70.0922 44.5005 68.0776 46.1418C66.2465 47.6332 65.9793 50.3162 67.4764 52.1351C68.317 53.1664 69.5462 53.6986 70.7824 53.6986C71.7343 53.6986 72.6973 53.3826 73.4881 52.7396C77.5022 49.6181 79.8 44.8398 79.8 39.5996C79.8 34.3595 77.5022 29.8832 73.4944 26.6148ZM84.2709 13.5055C82.4505 12.0251 79.7572 12.2802 78.2539 14.0988C76.7566 15.9178 77.0237 18.6018 78.8495 20.0921C84.8944 24.8562 88.35 32.1746 88.35 39.5996C88.35 47.0247 84.8873 54.1832 78.8542 59.2635C77.0284 60.7549 76.7612 63.4378 78.2585 65.2568C79.1046 66.2826 80.3283 66.8148 81.5645 66.8148C82.5219 66.8148 83.4793 66.4988 84.2756 65.8501C92.3044 59.4589 96.9 49.8845 96.9 39.5996C96.9 29.3148 92.3044 20.0424 84.2709 13.5055ZM53.6512 0.499324C51.6028 -0.420986 49.1963 -0.0470712 47.5184 1.439L23.4769 22.7246H8.55C3.82791 22.7246 0 26.5401 0 31.2438V48.2823C0 52.986 3.82791 56.8015 8.55 56.8015H23.484L47.5131 78.0818C48.5747 79.0161 49.9284 79.5135 51.3 79.5135C52.0905 79.5135 52.8958 79.3481 53.6441 79.0099C55.6997 78.0925 57 76.0675 57 73.8471V5.67552C57 3.44268 55.6997 1.41413 53.6512 0.499324Z"
                      fill="#43BA73"
                    />
                  </svg>
                </div>
                <div className="red-volume">
                  <svg
                    width="114"
                    height="91"
                    viewBox="0 0 114 91"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M112.391 83.521L96.5727 71.1308C104.034 64.5948 108.328 55.3543 108.328 45.5796C108.328 35.4096 103.724 25.7988 95.6996 19.3891C93.8787 17.9035 91.1848 18.1595 89.681 19.9845C88.1833 21.8095 88.4506 24.5033 90.2768 25.9989C96.3196 30.784 99.7762 37.977 99.7762 45.5796C99.7762 53.1803 96.3125 60.3734 90.2779 65.3248C90.0917 65.4774 89.993 65.686 89.8396 65.8612L81.9413 59.6759C82.0311 59.6815 82.1144 59.7338 82.2045 59.7338C83.1566 59.7338 84.1198 59.4167 84.9109 58.7713C88.9256 55.4789 91.224 50.6895 91.224 45.5796C91.224 40.4786 88.9238 35.6767 84.9096 32.3935C83.078 30.9079 80.3823 31.1695 78.8964 33C77.3987 34.8249 77.6659 37.5188 79.4977 39.0143C81.5137 40.6655 82.6718 43.0513 82.6718 45.5796C82.6718 48.1078 81.5137 50.4972 79.4986 52.1459C78.1233 53.2695 77.6314 55.0676 78.1046 56.6664L68.4182 49.0871V11.3949C68.4182 9.1533 67.1109 7.12003 65.0615 6.2031C63.0125 5.2794 60.6054 5.64831 58.9271 7.13943L38.2896 25.4783L6.91558 0.909989C6.13163 0.29787 5.20158 0 4.28222 0C3.01365 0 1.75381 0.562267 0.913025 1.63606C-0.545833 3.49485 -0.22192 6.18155 1.63782 7.63618L106.954 90.0889C108.825 91.5494 111.51 91.2156 112.957 89.3629C114.582 87.6695 114.244 84.981 112.391 83.521ZM11.4037 37.0334V54.1257C11.4037 58.8457 15.2326 62.5117 19.9559 62.5117H34.8937L58.9288 83.8593C59.9907 84.9632 61.3448 85.4617 62.7167 85.4617C63.5075 85.4617 64.313 85.2959 65.0615 84.9566C67.1175 84.0373 68.4182 82.0076 68.4182 79.7643V70.8015L15.8134 29.6089C13.1943 31.0689 11.4037 33.6684 11.4037 37.0334Z"
                      fill="#DB4B4B"
                    />
                  </svg>
                </div> */}
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonFooter className="ion-no-border" placeholder={undefined}>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="phone-footer-wraper-for-assessment-setup-pages">
                {/* <div className="dot-circles">
                  <ul>
                    <li className="active"></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div> */}
                <ul className="base-timeline">
                  <li className="base-timeline-item active"> </li>
                  <li className="base-timeline-item"></li>
                  <li className="base-timeline-item"></li>
                  <li className="base-timeline-item"></li>
                </ul>
                <div className="btn-wrap-sec hide-btn">
                  <IonButton className="generic-btn" placeholder={undefined}>
                    Retry
                  </IonButton>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};
export default PhoneAudioCheck;
